import React, { useEffect } from 'react';
import AppBar from '@material-ui/core/AppBar';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsIcon from '@material-ui/icons/Notifications';
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone';
import HelpIcon from '@material-ui/icons/Help';
import Tooltip from '@material-ui/core/Tooltip';
import Fade from '@material-ui/core/Fade';
import Typography from '@material-ui/core/Typography';
import Badge from '@material-ui/core/Badge';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import Popper from '@material-ui/core/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import i18n from '../../i18n';
import { userInfoState, notificationsState } from '../HomePage/HomeSlice';

import NotificationsPage from '../NotificationsPage/NotificationsPage';
import HelpPage from './HelpPage/HelpPage';
import ProfilePage from './ProfilePage/ProfilePage';
import useStyles from './styles';

export default function Header(props) {
  const classes = useStyles();
  const { drawerOpened } = props;
  const { t } = useTranslation();
  const user = useSelector(userInfoState);
  const notifications = useSelector(notificationsState);

  const [numberOfNewNotifications, setNumberOfNewNotifications] =
    React.useState(0);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorElHelpPage, setAnchorElHelpPage] = React.useState(null);
  const [helpPageOpened, setHelpPageOpened] = React.useState(false);

  const [anchorElProfilePage, setAnchorElProfilePage] = React.useState(null);
  const [profilePageOpened, setProfilePageOpened] = React.useState(false);

  const env = process.env.REACT_APP_STAGE;
  const [language, setLanguage] = React.useState(i18n.language);
  useEffect(() => {
    if (language === 'en' || language.indexOf('en-') !== -1) {
      setLanguage('en');
    } else if (language === 'fr' || language.indexOf('fr-') !== -1) {
      setLanguage('fr');
    } else if (language === 'de' || language.indexOf('de-') !== -1) {
      setLanguage('de');
    } else {
      setLanguage('en');
    }
  }, []);
  useEffect(() => {
    setNumberOfNewNotifications(
      notifications.filter(
        (item) =>
          new Date().getDate() === new Date(item.notificationDate).getDate() &&
          new Date().getMonth() ===
            new Date(item.notificationDate).getMonth() &&
          new Date().getFullYear() ===
            new Date(item.notificationDate).getFullYear(),
      ).length,
    );
  }, [notifications]);

  const handleDrawerOpen = () => {
    props.onChange(true);
  };
  const handleDrawerClose = () => {
    props.onChange(false);
  };

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  function getAnchorEl() {
    setAnchorEl(null);
  }
  function isNotProd() {
    return env !== 'prod';
  }

  function countryToFlag(isoCode) {
    if (isoCode === 'en') {
      return `${process.env.PUBLIC_URL}/us.svg`;
    }
    if (isoCode === 'fr') {
      return `${process.env.PUBLIC_URL}/france.svg`;
    }
    return `${process.env.PUBLIC_URL}/germany.svg`;
  }

  const handleChange = (event) => {
    setLanguage(event.target.value);
    i18n.changeLanguage(event.target.value);
  };

  const handleHelpPageOpen = (event) => {
    setHelpPageOpened(!helpPageOpened);
    setAnchorElHelpPage(anchorElHelpPage ? null : event.currentTarget);
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    if (drawerOpened) handleDrawerClose();
    setAnchorEl(null);
  };

  const handleHelpPageClickAway = () => {
    setHelpPageOpened(false);
    setAnchorElHelpPage(null);

    setProfilePageOpened(false);
    setAnchorElProfilePage(null);
  };

  const handleProfilePageOpen = (event) => {
    setProfilePageOpened(!profilePageOpened);
    setAnchorElProfilePage(anchorElProfilePage ? null : event.currentTarget);
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    if (drawerOpened) handleDrawerClose();
    setAnchorEl(null);
  };

  const handleProfilePageClickAway = () => {
    setProfilePageOpened(false);
    setAnchorElProfilePage(null);

    setHelpPageOpened(false);
    setAnchorElHelpPage(null);
  };

  return (
    <div>
      <AppBar
        className={clsx(classes.appBar, {
          [classes.appBarShift]: drawerOpened,
        })}
      >
        <Toolbar data-testid="header-toolbar">
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={drawerOpened ? handleDrawerClose : handleDrawerOpen}
            edge="start"
            className={classes.drawerMenuButton}
          >
            <MenuIcon />
          </IconButton>
          <Typography className={classes.menu} aria-label="menu">
            {t('Menu')}
          </Typography>
          <img
            className={classes.logo}
            src={`${process.env.PUBLIC_URL}/total-logo.png`}
            alt="img"
          />
          <Typography
            edge="start"
            className={classes.appName}
            color="inherit"
            aria-label="menu"
          >
            WOLF
          </Typography>
          <Typography className={classes.testBanner} aria-label="test-banner">
            {isNotProd() && `TEST`}
          </Typography>
          <div className={classes.grow} />
          {(user.internal || user.hasEmilyDRights || user.externalMax) && (
            <div>
              {numberOfNewNotifications > 0 ? (
                <IconButton
                  data-testid="notifications-button"
                  className={classes.notificationButton}
                  onClick={(e) => handleClick(e)}
                >
                  <Badge
                    badgeContent={numberOfNewNotifications}
                    classes={{ badge: classes.customBadge }}
                  >
                    <NotificationsNoneIcon />{' '}
                  </Badge>{' '}
                </IconButton>
              ) : (
                <IconButton
                  data-testid="notifications-button"
                  className={classes.emptyNotificationButton}
                  onClick={(e) => handleClick(e)}
                >
                  <NotificationsIcon />{' '}
                </IconButton>
              )}
            </div>
          )}
          <Tooltip TransitionComponent={Fade} title={t('help')} arrow>
            <span>
              <IconButton
                data-testid="help-button"
                disabled={helpPageOpened}
                className={classes.helpIcon}
                onClick={handleHelpPageOpen}
              >
                <HelpIcon />{' '}
              </IconButton>
            </span>
          </Tooltip>

          <Typography className={classes.userName}>{user.name}</Typography>
          <IconButton
            className={classes.userIcon}
            data-testid="profile-button"
            disabled={profilePageOpened}
            onClick={handleProfilePageOpen}
          >
            <AccountCircleIcon />
          </IconButton>
          <div className={classes.selectLanguageSection}>
            <img
              src={countryToFlag(language)}
              alt="flag"
              className={classes.flagStyle}
            />
            <FormControl className={classes.formControl}>
              <Select
                className={classes.selectLanguage}
                disableUnderline
                inputProps={{
                  classes: {
                    icon: classes.icon,
                  },
                }}
                value={language}
                onChange={handleChange}
              >
                <MenuItem className={classes.selectMargin} value="fr">
                  {t('Français')}
                </MenuItem>
                <MenuItem value="en"> {t('Anglais')}</MenuItem>
                <MenuItem value="de"> {t('Allemand')}</MenuItem>
              </Select>
            </FormControl>
          </div>
        </Toolbar>
      </AppBar>
      <NotificationsPage
        initialAnchorEl={anchorEl}
        sendAnchorEl={getAnchorEl}
        notifications={notifications}
      />
      <ClickAwayListener onClickAway={handleHelpPageClickAway}>
        <Popper
          open={helpPageOpened}
          anchorEl={anchorElHelpPage}
          className={classes.popperStyle}
          placement="bottom"
        >
          <HelpPage />
        </Popper>
      </ClickAwayListener>

      <ClickAwayListener onClickAway={handleProfilePageClickAway}>
        <Popper
          open={profilePageOpened}
          anchorEl={anchorElProfilePage}
          className={classes.popperStyle}
          placement="bottom"
        >
          <ProfilePage
            group={
              user.externalGroupsDTO == null
                ? '-'
                : user.externalGroupsDTO.group
            }
            role={
              user.externalGroupsDTO == null ? '-' : user.externalGroupsDTO.role
            }
            site={
              user.externalGroupsDTO == null ? '-' : user.externalGroupsDTO.site
            }
            persona={
              user.externalGroupsDTO == null
                ? '-'
                : user.externalGroupsDTO.persona
            }
            roleFr={
              user.externalGroupsDTO == null
                ? '-'
                : user.externalGroupsDTO.roleFr
            }
            roleGn={
              user.externalGroupsDTO == null
                ? '-'
                : user.externalGroupsDTO.roleGn
            }
          />
        </Popper>
      </ClickAwayListener>
    </div>
  );
}
